export default function Redirect() {
    let params = new URLSearchParams(window.location.search);
    let playlistId = params.get("playlistId")
    window.location.href = `https://open.spotify.com/playlist/${playlistId}`
    return false
}